import '@aws-amplify/ui-react/styles.css';
import { signIn } from 'aws-amplify/auth';
import awsconfig from './aws-exports';
import { Amplify } from 'aws-amplify';
import { Authenticator } from '@aws-amplify/ui-react';
// セッションストレージ用
import { sessionStorage } from 'aws-amplify/utils';
import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito'

import { components } from './pages/login/Compornents';
import { formFields } from './pages/login/FormFields';
import { vocabularies } from './pages/login/Vocablaries';
import { HEADER_DISABLED_KEY, SS_CHANGED, getSessionItem } from "./pages/storageCheck/storageCheck";
import styled from "@emotion/styled";
import { AppBar, Grid, Toolbar, Box, Typography } from "@mui/material";
import React, { useState, createContext } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Redirect from './pages/redirect/redirect';
import InputSarchCondition from './pages/search/inputSearchCondition';
import KigyoInfoList from "./pages/result/kigyoInfoList";
import KigyoInfoDetail from "./pages/result/kigyoInfoDtail";
import AccountList from "./pages/account/accountList";
import Activation from './pages/activation/activation';
import Error from './pages/error/error';
import { HeaderToAccountInfo, HeaderToSearch } from './pages/header/headerToDisp';
import { HeaderToLogout } from './pages/header/headerToLogout';

Amplify.configure(awsconfig);
cognitoUserPoolsTokenProvider.setKeyValueStorage(sessionStorage);

const BaseAppBar = styled(AppBar)(({ }) => ({
    backgroundColor: '#FFFFFF',
    minHeight: '3rem',
    color: '#000000',
}));

const HeaderGrid = styled(Grid)(({ }) => ({
    textAlign: 'center',
    fontSize: '1rem',
    width: '100%',
    marginTop: '0.3rem'
}));

const WrrapBox = styled(Box)(({ }) => ({
    minWidth: 1000,
    overflowX: 'auto',
    overflowY: 'hidden',
}));

const Footer = styled.footer`
    border-top: 0.1rem solid #000000;
    overflow: auto;
    width: 85%;
    font-size: 1.2rem;
    margin: 0 auto;
    margin-bottom: 2rem;
    padding-top: 0.5rem;
    text-align: center;
`;

// セッションタイムアウトメッセージContext
export const SessionTimeoutMsg = createContext<SessionTimeoutMsg>({} as SessionTimeoutMsg);

// ログイン画面の日本語設定
vocabularies('ja');
// Propsの型を定義
interface AppProps {
    authComp: boolean;
    error: boolean;
}

const App: React.FC<AppProps> = ({ authComp, error }) => {

    // タイトル
    document.title = 'TSR-Eyes';

    // セッションタイムアウトメッセージ:非表示
    const [hidden, setHidden] = useState<string>('hidden');
    const sessionTimeoutMsgState = { hidden, setHidden };

    const [disable, setDisable] = useState(
        () => getSessionItem(HEADER_DISABLED_KEY) === "true"
    );

    React.useEffect(() => {
        const handler = (e: Event) => {
            const { key, value } = (e as CustomEvent<{ key: string; value: string }>).detail ?? {};
            if (key === HEADER_DISABLED_KEY) setDisable(value === "true");
        };
        window.addEventListener(SS_CHANGED, handler);
        return () => window.removeEventListener(SS_CHANGED, handler)
    }, []);

    if (error) {
        return (
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Activation err={error} />} />
                    <Route path={`/activation`} element={<Activation err={error} />} />
                    <Route path={`/Error`} element={<Error />} />
                </Routes>
            </BrowserRouter>
        );
    } else {
        if (!authComp) {
            // ローカルストレージにKEY項目.契約者コードが登録されていない場合
            return (
                <BrowserRouter>
                    <Routes>
                        <Route path="/" element={<Activation err={error} />} />
                        <Route path={`/activation`} element={<Activation err={error} />} />
                        <Route path={`/Error`} element={<Error />} />
                    </Routes>
                </BrowserRouter>
            );
        } else {
            // ローカルストレージにKEY項目.契約者コードが登録されている場合
            return (
                <SessionTimeoutMsg.Provider value={sessionTimeoutMsgState}>
                    <Authenticator.Provider>
                        <Authenticator hideSignUp={true} components={components} formFields={formFields} services={{
                            async handleSignIn({ username, password, options }) {
                                const localData = localStorage.getItem('contractId');

                                return signIn({
                                    username,
                                    password,
                                    options: {
                                        ...options,
                                        clientMetadata: {
                                            ...options?.clientMetadata,
                                            from_local_storage: localData || 'none',
                                        },
                                    },
                                });
                            },
                        }}>
                            {({ signOut, user }) => (
                                <div className="flex flex-col min-h-screen overflow-hidden">
                                    <WrrapBox>
                                        <BrowserRouter>
                                            <BaseAppBar position="sticky">
                                                <Toolbar>
                                                    <HeaderGrid container spacing={0}>
                                                        <Grid size={1}>
                                                            <img src={`${process.env.PUBLIC_URL}/symbol-color-min.jpg`} width="50px" />
                                                        </Grid>
                                                        <Grid size={6}></Grid>
                                                        {disable ? <></> :
                                                            <Grid size={5}>
                                                                <Box display='flex' alignItems='center' justifyContent='flex-end' gap={2}>
                                                                    <HeaderToSearch />
                                                                    <HeaderToAccountInfo />
                                                                    <Typography variant='body1'>{user?.signInDetails?.loginId}様</Typography>
                                                                    <HeaderToLogout signOut={signOut} />
                                                                </Box>
                                                            </Grid>
                                                        }
                                                    </HeaderGrid>
                                                </Toolbar>
                                            </BaseAppBar>
                                            <Routes>
                                                <Route path="/" element={<Redirect />} />
                                                <Route path={`/account`} element={<AccountList />} />
                                                <Route path={`/search`} element={<InputSarchCondition conditions={[]} />} />
                                                <Route path={`/result`} element={<KigyoInfoList />} />
                                                <Route path={`/result/detail`} element={<KigyoInfoDetail />} />
                                                <Route path={`/Error`} element={<Error />} />
                                            </Routes>
                                        </BrowserRouter>
                                        {/** フッター */}
                                        <Footer>
                                            &copy; TOKYO SHOKO RESEARCH, LTD.
                                        </Footer>
                                    </WrrapBox>
                                </div>
                            )}
                        </Authenticator>
                    </Authenticator.Provider>
                </SessionTimeoutMsg.Provider>
            );
        }
    }

}

export default App;
